$(function(){

	$('#imgZoom').elevateZoom({
		zoomType: "lens", 
		lensShape: "round", 
		lensBorderColour: "#fff",
		borderColour: "#fff",
		lensSize: 200
	});

	
})